import _, {isEqual} from 'lodash'
import React, {Component} from 'react';
import {
  Alert as AlertComponent,
  Button,
  Col,
  Container,
  Popover,
  PopoverBody,
  Row
} from 'reactstrap';
import {Modal, ModalBody, ModalFooter} from 'reactstrap';
import {userData} from '../../util/userData';
import {verifyIfAdmin} from '../RankingReportContainer/lib/https';
import {openRankingReport, previewRankingReport} from '../RankingReportContainer/lib/utils';
import {RunReportContainer} from '../RankingReportContainer/runReportContainer';
import {AttributesBar} from './lib/AttributesBar';
import ColumnForm from './lib/ColumnForm';
import {
  createReport,
  getHierarchy,
  getReport,
  getReportDefinition,
  updateReport,
  validateReportName
} from './lib/https';
import {containerProps, containerState, IColumn, IRankingReport} from './lib/interfaces';

export class RankingReportCreationContainer extends Component<containerProps, containerState> {
  state: containerState = {
    report: {
      id: undefined,
      name: '',
      lastSaved: '',
      rank: undefined,
      within: undefined,
      showIndustryAverages: false,
      showRollupAverages: false,
      columns: [],
      requestedAvids: [],
      created_by: 0
    },
    dataGridColumns: [
      { header: 'Hierarchy Record', property: 'hierarchyRecord' },
      { header: 'Hierarchy Level', property: 'hierarchyLevel' }
    ],
    rankAvids: [],
    requestedAvidIds: [],
    requestedAvidsLabel: [],
    DataGridRecords: [],
    isColumnFormPopUpOpen: false,
    inputs: new Map([
      ['rank', true],
      ['within', true],
      ['columns', true],
      ['name', true]]),
    dragAndDropOrder: [],
    saveNotification : {
      isOpen: false,
      text: '',
      actionRequired: false
    },
    records: [],
    nonParentList: [],
    listOfAvids: [],
    verifyNameWarning: false,
    verifyFormWarning: false,
    hierarchyLevel: '',
    badInputs: [],
    showReplaceModal: false,
    replaceModalText: '',
    replaceOption: false,
    userId: undefined,
    isAdmin: false,
    dismissText: 'No',
    placeholderForPeriodDropdownMenu: 'Loading...',
  }

  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.setUserId()
  }

  setUserId() {
    userData.getUserId().then((id) => {
      getHierarchy('Bankwide_0', id).then((res) => {
        this.setState({rankAvids: res.hierarchyLevels, nonParentList: res.nonParentList, listOfAvids: res.listOfAvids}, () => {
          this.updateRank(this.state.report.rank)
          this.loadRankingReport();
        });
      })
      this.setState({userId: id})
      verifyIfAdmin(id).then((isAdmin) => {
        this.setState({ isAdmin })
      })
    })
  }

  componentDidUpdate(prevProps: containerProps, prevState: containerState) {
    if (prevState.inputs !== this.state.inputs) {

    }
  }

  getReportColumns() {
    let updatedReport = this.state.report;
    // updatedReport.columns = COLUMNS;
    getReport(undefined).then((reportDefinition) => {
      if (reportDefinition) {
        reportDefinition.forEach((column) => {
          updatedReport.columns.push(column);
        });
      }
    });
    const columnsOrder = updatedReport.columns.reduce((accumulator, column) => {
      return accumulator.concat(column.id);
    }, [])
    this.setState({report: updatedReport, dragAndDropOrder: columnsOrder});
  }

  addColumn() {

  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    let partialState = {};
    partialState['report'] = this.state.report;
    partialState['report'][name] = value;

    this.setState(partialState)
  }

  deleteColumn(columnID: number) {
    const {report} = this.state;
    let updatedReport = report;
    updatedReport.columns = report.columns.map((column) => {
      column.hasBeenDeleted = (column.id == columnID || column.hasBeenDeleted);
      return column;
    });

    this.setState({isColumnFormPopUpOpen: false, report: updatedReport});
  }

  updateColumnsOrder(columnIDs: number[]) {
    const { dragAndDropOrder } = this.state;
    let updatedReport = this.state.report;

    // Only update state when order of columns have really changed
    if (!isEqual(columnIDs, dragAndDropOrder)) {

      let updatedColumns = updatedReport.columns.map((column) => {
        column.order = columnIDs.indexOf(column.id);
        return column;
      });

      updatedColumns.sort((a, b) => {
        if (a.order < b.order)
          return -1;
        if (a.order > b.order)
          return 1;
      });

      updatedReport.columns = updatedColumns;

      this.setState({dragAndDropOrder: columnIDs, report: updatedReport});
    }
  }

  updateRank(avidID: string) {
    let {report, rankAvids} = this.state;
    let iHierarchyOption = rankAvids.find((avid) => avid.hierarchy == avidID);
    const hierarhyLevel = iHierarchyOption ? iHierarchyOption.hierarchyLevel : ''
    const path = ((rankAvids && avidID) ? iHierarchyOption.path : []);
    report.rank = avidID;
    report.within = (path.length == 1? path[0] : undefined);
    this.setState({report: report, hierarchyLevel: hierarhyLevel }, () => {
      if (path.length == 1)
        this.setRequestedAvids()
    });
  }

  updateWithin(withinID: string) {
    let {report} = this.state;
    report.within = withinID;
    this.setState({report: report}, () => {this.setRequestedAvids()});
  }

  setRequestedAvids() {
    const {rankAvids, report, listOfAvids} = this.state;
    const rank = report.rank;
    const within = report.within;
    const withinAvid = listOfAvids.find(i => i.avid.label === within);

    const requestedRankAvid = rankAvids.find((avid) => avid.hierarchy == rank);
    let hierarchyLevelChildrenAvids;
    // if within option is in the path (avid -> bankwide), there is no need to filter its children.
    if (!requestedRankAvid.path.includes(within))
      hierarchyLevelChildrenAvids = requestedRankAvid.children.filter((hierarchyOption) => {
        if (hierarchyOption.path.includes(withinAvid.avid.nextLink)) {
          return true
        }
      });
    else hierarchyLevelChildrenAvids = requestedRankAvid.children;

    let newRequestedAvidsIds = [];
    let newRequestedAvids = [];
    let requestedAvids = [];

    let avidsRequestedRows: any[] = [];

    hierarchyLevelChildrenAvids.forEach((item) => {
      newRequestedAvids.push(item.avid.label);
      newRequestedAvidsIds.push(item.avid.id);
      let row = Object.defineProperty({}, 'hierarchyRecord', {
        value: item.avid.label,
        writable: false
      })
      Object.defineProperty(row, 'hierarchyLevel', {
        value: item.avid.parentLabel,
        writable: false
      })
      avidsRequestedRows.push(row)
      requestedAvids.push({
        id: item.avid.id,
        label: item.avid.label,
        parentLabel: item.avid.parentLabel,
        parentAvid: item.avid.prevLink,
        parentAvidId: item.avid.parentId,
      })
    })

    report.requestedAvids = requestedAvids;


    this.setState({requestedAvidIds: newRequestedAvidsIds, requestedAvidsLabel: newRequestedAvids, report: report}, () => {
      this.setAvidsColumns(avidsRequestedRows);
    });
  }

  setAvidsColumns(records: any[]) {
    let updatedDGRecords = [];

    records.forEach((item) => {
      let row = Object.defineProperty({}, 'hierarchyRecord', {
        value: item.hierarchyRecord,
        writable: false
      });
      Object.defineProperty(row, 'hierarchyLevel', {
        value: item.hierarchyLevel,
        writable: false
      })
      updatedDGRecords.push(row);
    });

    this.setState({DataGridRecords: updatedDGRecords});
  }

  toggleShowIndustryAverages(isChecked: boolean) {
    let {report} = this.state;
    report.showIndustryAverages = isChecked;
    this.setState({report: report});
  }
  toggleShowRollupAverages(isChecked: boolean) {
    let {report} = this.state;
    report.showRollupAverages = isChecked;
    this.setState({report: report});
  }
  toggleAddNumberOfSurveysColumn(columnID:number, isChecked: boolean) {
    let updatedReport = this.state.report;
    const needle = updatedReport.columns.findIndex((column) => column.id == columnID);

    updatedReport.columns[needle].addNumberOfSurveys = isChecked;
    this.setState({report: updatedReport});
  }

  toggleColumnPopUp (isOpen: boolean, columnID?: number) {
    this.setState({isColumnFormPopUpOpen: isOpen, columnID: columnID});
  }

  updateColumn(columnID: number, updatedColumn: IColumn) {
    let updatedReport = this.state.report;
    updatedColumn.order = this.state.dragAndDropOrder.findIndex(id => id == columnID);
    const { dataGridColumns } = this.state;
    let newColumnFlag = true;

    updatedReport.columns = this.state.report.columns.map((item) => {
      if (item.id == columnID) {
        newColumnFlag = false;
        item = updatedColumn;
      }
      return item;
    });

    if (newColumnFlag) {
      updatedColumn.id = Date.now();
      updatedColumn.order = (updatedReport.columns.length > 0 ? updatedReport.columns[updatedReport.columns.length - 1].order + 1 : 0);
      updatedReport.columns.push(updatedColumn);
      let updatedDGColumns = dataGridColumns;
      if (updatedColumn.addRankingColumn)
        updatedDGColumns.push({
          header: 'Rank',
          property: `rank-${updatedColumn.id}`
        });
      updatedDGColumns.push({
        header: 'Measure',
        property: `measure-${updatedColumn.id}`
      });
      if (updatedColumn.addNumberOfSurveys)
        updatedDGColumns.push({
          header: 'n',
          property: `n-${updatedColumn.id}`
        });
    }

    this.setState({report: updatedReport, isColumnFormPopUpOpen: false},);
  }

  saveReportWorkflow(saveAs?: boolean) {
    const {report, inputs, isAdmin} = this.state;
    this.dismissWarning();
    this.dismissVerifiedNameWarning()
    if (saveAs || report.id === undefined) {
      this.createNewReportWorkflow(report, inputs)
    } else {
      // bypass the name verification, user is editing an already existent report
      this.setState({inputs: inputs}, () => {
        if (this.validateForm(inputs)) {
          userData.getUserId().then((userId) => {
            if (report.created_by === userId || isAdmin) {
              this.setState({
                showReplaceModal: true, 
                replaceModalText: `${report.name} name already exists, do you want to replace it?`,
                replaceOption: true,
                dismissText: 'No'
              })
              // this.saveReport(report)
            } else {
              this.setState({
                showReplaceModal: true,
                replaceModalText: `You are not authorized to make changes to the ${report.name} ranking report. Only Admins or the report owner can edit this report. Please save your report with a different name.`,
                replaceOption: false,
                dismissText: 'Ok'
              })
            }
          })
        }
      });
    }
  }

  // Save As and Creating a new Report are the same workflows
  createNewReportWorkflow(report: IRankingReport, inputs: Map<string, boolean>) {
    validateReportName(report.name).then((v) => {
      if (v) {
        this.setState({inputs: inputs}, () => {
          if (this.validateForm(inputs)) {
            this.saveReport(report)
          }
        });
      } else {
        this.setState({verifyNameWarning: true})
      }
    })
  }

  validateForm(inputs: Map<string, boolean>) {
    let isValidForm = true;
    let badInputs = []
    inputs.forEach((isValid, input) => {
      if (this.state.report[input] == undefined) {
        isValidForm = false;
        inputs.set(input, false);
        badInputs.push(input)
      } else {
        if (input == 'columns' || input == 'name') {
          if (this.state.report[input].length > 0) {
            inputs.set(input, true);
          } else {
            inputs.set(input, false);
            isValidForm = false;
            badInputs.push(input)
          }
        } else inputs.set(input, true);
      }
    }, this);

    this.setState({inputs, badInputs, verifyFormWarning: !isValidForm})

    return isValidForm
  }

  saveReport(report: IRankingReport) {
    userData.getUserId().then((id) => {
      report.id = undefined
      createReport(report.name, JSON.stringify(report), id).then((res) => {
        if (res) {
          const successNotification = {
            isOpen: true,
            text: 'Report successfully saved',
            actionRequired: true
          }
          report.id = Number(res)
          this.setState({saveNotification: successNotification, report: report});
        } else {
          const warnNotification = {
            isOpen: true,
            text: 'Report could not be saved',
            actionRequired: false
          }
          this.setState({saveNotification: warnNotification});
        }
      });
    });
  }

  updateReport(report: IRankingReport) {
    userData.getUserId().then((id) => {
      updateReport(report.name, JSON.stringify(report), id, report.id).then((res) => {
        if (res) {
          const successNotification = {
            isOpen: true,
            text: 'Report successfully saved',
            actionRequired: true
          }
          report.id = Number(res)
          this.setState({saveNotification: successNotification, report: report});
        } else {
          const warnNotification = {
            isOpen: true,
            text: 'Report could not be saved',
            actionRequired: false
          }
          this.setState({saveNotification: warnNotification});
        }
      });
    });
  }

  dismissWarning() {
    const dismissedWarning = {
      isOpen: false,
      text: '',
      actionRequired: false
    }
    this.setState({ saveNotification: dismissedWarning });
  }

  dismissVerifiedNameWarning() {
    this.setState({verifyNameWarning: false}, () => {
      document.getElementById("inputName").focus()
    })
  }
  dismissFormWarning() {
    this.setState({verifyFormWarning: false}, () => {
    })
  }

  loadRankingReport() {
    let updatedReport = this.state.report;
      const searchParameter = new URLSearchParams(window.location.search);
    if (searchParameter.has('report_id')) {
      const reportId = parseInt(searchParameter.get('report_id'));
      getReportDefinition(reportId).then((res) => {
        
        let { hierarchyLevel } = this.state

        if (res.rank)
          hierarchyLevel = res.rank

        updatedReport.name = res.name;
        updatedReport.rank = res.rank;
        updatedReport.within = res.within;
        updatedReport.showIndustryAverages = res.showIndustryAverages;
        updatedReport.showRollupAverages = res.showRollupAverages;
        updatedReport.id = reportId;
        updatedReport.lastSaved = res.lastSaved;
        updatedReport.requestedAvids = res.requestedAvids
        updatedReport.created_by = res.created_by

        this.setState({report: updatedReport, hierarchyLevel});
        const reversedColumns = res.columns.reverse();
        reversedColumns.forEach((column) => {
          this.updateColumn(column.id, column);
        });
      })
    }
  }

  runReport() {
    this.setState({shouldRunReport: true})
    const previewOfReport = _.cloneDeep(this.state.report);

    previewOfReport.name = `Preview ${previewOfReport.name.length ? 'for ' + previewOfReport.name : ''}`;
    previewOfReport.id = undefined;

    userData.getUserId().then((userId) => {
      createReport(previewOfReport.name, JSON.stringify(previewOfReport), userId, true).then((res) => {
        if (res) {
          previewRankingReport(Number(res))
        } else {
          const warnNotification = {
            isOpen: true,
            text: 'Report preview could not be processed',
            actionRequired: false
          }
          this.setState({saveNotification: warnNotification});
        }
      })
    })
  }

  hasLoadedEvent(hasLoaded: boolean) {
    if (hasLoaded) {
      this.setState({placeholderForPeriodDropdownMenu: 'Select Period'});
    } else {
      this.setState({placeholderForPeriodDropdownMenu: 'Loading...'});
    }
  }

  render() {
    const {withinChildrenOptions, dragAndDropOrder } = this.state;
    const {rank, showRollupAverages, within, showIndustryAverages, columns, name, requestedAvids, id} = this.state.report;
    let filteredColumns = columns.filter((c) => c.hasBeenDeleted == false);
    const {rankAvids, isColumnFormPopUpOpen, columnID, inputs} = this.state;
    const currentColumn = ((columns.length > 0 && columnID) ? columns.find((column) => column.id == columnID): undefined);
    const activeColumns = columns.filter((column) => column.hasBeenDeleted == false);
    const isOrderComplete = dragAndDropOrder.length === columns.length
    const searchParams = new URLSearchParams(window.location.search)
    const showSaveAsButton = searchParams.has('report_id') || id
    return (
      <Row>
        <Modal isOpen={this.state.showReplaceModal}
               wrapClassName="blacklight"
               modalClassName="blacklight-modal">
          <ModalBody>
            {this.state.replaceModalText}
          </ModalBody>
          <ModalFooter>
            <Button color='primary' onClick={() => this.setState({showReplaceModal: false})}>{this.state.dismissText}</Button>
            {this.state.replaceOption &&
            <Button color='primary' onClick={() => {
              this.setState({showReplaceModal: false}, () => {
                this.updateReport(this.state.report)
              })
            }}>Yes</Button>
            }
          </ModalFooter>
        </Modal>
        <Col sm={3}>
          <AttributesBar
            runReport={() => {this.runReport()}}
            updateRank={(avidID) => this.updateRank(avidID)}
            updateWithin={(avidID) => this.updateWithin(avidID)}
            toggleShowIndustryAverages={(isChecked) => this.toggleShowIndustryAverages(isChecked)}
            toggleShowRollupAverages={(isChecked) => this.toggleShowRollupAverages(isChecked)}
            toggleColumnPopUp={(isOpen, columnID?: number) => this.toggleColumnPopUp(isOpen, columnID)}
            updateColumnsOrder={(columnIDs: number[]) => this.updateColumnsOrder(columnIDs)}
            rank={rank}
            within={within}
            showIndustryAverages={showIndustryAverages}
            showRollupAverages={showRollupAverages}
            columns={filteredColumns}
            rankAvids={rankAvids}
            isColumnFormPopUpOpen={isColumnFormPopUpOpen}
            isValidColumns={inputs.get('columns')}
            isValidRank={inputs.get('rank')}
            isValidWithin={inputs.get('within')}
            withinChildrenOptions={withinChildrenOptions}
            nonParentList={this.state.nonParentList}
            disableAddColumnButton={this.state.hierarchyLevel.length === 0}
          />
          <Popover
            container='RankingReportCreationContainer'
            target='column-edit-section'
            placement='right'
            isOpen={this.state.isColumnFormPopUpOpen}
          >
            <PopoverBody>
              <ColumnForm
                hierarchyLevel={this.state.hierarchyLevel}
                togglePopover={() => this.toggleColumnPopUp(!this.state.isColumnFormPopUpOpen)}
                updateColumn={(columnID: number, updatedColumn: IColumn) => this.updateColumn(columnID, updatedColumn)}
                deleteColumn={(columnID: number) => this.deleteColumn(columnID)}
                toggleShowIndustryAverages={(columnID, isChecked) => this.toggleAddNumberOfSurveysColumn(columnID, isChecked)}
                column={currentColumn}
                hasLoadedEvent={(hasLoaded: boolean) => this.hasLoadedEvent(hasLoaded)}
                placeholderForPeriodDropdownMenu={this.state.placeholderForPeriodDropdownMenu}
              />
            </PopoverBody>
          </Popover>
        </Col>
        <Col sm={9}>
          <Container>
            <Row>
              <Col sm={10}>
                <AlertComponent color="success" isOpen={this.state.saveNotification.isOpen} toggle={() => this.dismissWarning()}>
                  <p className='strong' style={{marginBottom: 0}}>{this.state.saveNotification.text} <a href="/rankingReport" className={(this.state.saveNotification.actionRequired ? 'alert-link' : "hide")}>Go to Ranking Reports List</a></p>
                </AlertComponent>
                <AlertComponent color="warning" isOpen={this.state.verifyNameWarning} toggle={() => this.dismissVerifiedNameWarning()}>
                  <p className="strong" style={{marginBottom: 0}}>Report with "{this.state.report.name}" name already exists. Please save this report with a different name.</p>
                </AlertComponent>
                <AlertComponent color="warning" isOpen={this.state.verifyFormWarning} toggle={() => this.dismissFormWarning()}>
                  <p className="strong" style={{marginBottom: 0}}>{`Your report was not saved for the following reason: these fields are required ${this.state.badInputs.join(', ')}`}</p>
                </AlertComponent>
              </Col>
            </Row>
            <Row>
              <Col sm={8}>
                <input id="inputName" name='name' type="text" placeholder='Report Name' value={(name ? name : '')} onChange={this.handleInputChange}/>
                <span className={'text-danger ' + (inputs.get('name') ? 'd-none' : '')}>This is a required field</span>
              </Col>
              <Col sm={4}>
                    <Button
                        color="warning"
                        style={{ marginLeft: "1rem" }}
                        className="right"
                        onClick={() => {
                            window.location.href = '/rankingReport';
                        }}
                    >
                      Cancel
                    </Button>
                { showSaveAsButton &&
                    <Button
                        color="secondary"
                        style={{ marginLeft: "1rem" }}
                        className="right"
                        onClick={() => {
                          this.saveReportWorkflow(true);
                        }}
                    >
                      Save As
                    </Button>
                }
                <Button color="primary" style={{padding: '0px 30px'}} className="right" onClick={() => {
                  this.saveReportWorkflow();
                }}>Save</Button>
              </Col>
            </Row>
            <Row>
              <Col sm={12} className='ranking-report-datagrid'>
                {(requestedAvids.length > 0 && isOrderComplete) &&
                <RunReportContainer
                  // @ts-ignore
                    toggleShouldRunReport={() => {this.setState({shouldRunReport: false})}}
                    reportName={this.state.report.name}
                    columns={activeColumns}
                    requestedAvids={this.state.report.requestedAvids}
                    dragAndDropOrder={(dragAndDropOrder && dragAndDropOrder.length > 0 ? dragAndDropOrder : [])}
                    shouldRunReport={false}
                    listOfAvids={this.state.listOfAvids}
                />
                }
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    );
  }
}
